import { MemberStatus, OAuthProvider } from "@upsquad/shared";
import { Navigate, Outlet } from "react-router";
import { getIsAuthenticated, getIsProfileComplete, getIsStaff } from "@/src/auth/store/auth-selectors";
import { Spinner } from "@/src/common/components/ui";
import { getSubdomain } from "@/src/common/lib/subdomain";
import { useAppSelector } from "@/src/common/redux/store";
import { useGetMyMembershipBySlugQuery } from "@/src/community/services/community-http.service";
import { ONBOARDING_ROUTES } from "@/src/onboarding/constants/onboarding-routes";
import { POST_ROUTES } from "@/src/post/constants/post-routes";

export function AuthRouteLayout() {
	const isAuthenticated = useAppSelector(getIsAuthenticated);
	const isProfileComplete = useAppSelector(getIsProfileComplete);
	const isStaff = useAppSelector(getIsStaff);
	const subdomain = getSubdomain();

	const params = new URLSearchParams(window.location.search);
	const isPopupRedirect =
		(params.get("mode") === OAuthProvider.GOOGLE || params.get("mode") === OAuthProvider.MICROSOFT) && !!params.get("redirect");

	const shouldCheckMembership = !!subdomain && isAuthenticated && isProfileComplete && !isPopupRedirect;
	const { data, error, isLoading } = useGetMyMembershipBySlugQuery(subdomain ?? "", { skip: !shouldCheckMembership });

	if (!isAuthenticated || isPopupRedirect) {
		return <Outlet />;
	}

	if (!isProfileComplete) {
		return <Navigate to={ONBOARDING_ROUTES.PROFILE} replace />;
	}

	if (subdomain) {
		if (isLoading) {
			return (
				<div className="flex min-h-screen items-center justify-center">
					<Spinner size="lg" />
				</div>
			);
		}

		if (isStaff) {
			return <Navigate to={POST_ROUTES.FEED} replace />;
		}

		if (error || !data || data.status === null || data.status === MemberStatus.INVITED) {
			return <Navigate to={ONBOARDING_ROUTES.JOIN_COMMUNITY} replace />;
		}

		if (data.status !== MemberStatus.APPROVED) {
			return <Navigate to={ONBOARDING_ROUTES.PENDING_JOIN_COMMUNITY} replace />;
		}

		return <Navigate to={POST_ROUTES.FEED} replace />;
	}

	return <Navigate to="/" replace />;
}
